<script setup lang="ts">
  import { Button } from '@/components/ui/button'
  import { useThemeColor } from '@/composables/useThemeColorV3'
  import { useTranslation } from '@/composables/useTranslation'
  import { computed } from 'vue'
  import { LoaderCircle } from 'lucide-vue-next'

  interface Props {
    class?: string
    loading?: boolean
    disabled?: boolean
    accessibleName?: string
  }

  const props = defineProps<Props>()
  const themeColor = computed(() => useThemeColor().value)
  const { t } = useTranslation({
    en: {
      complete: 'Complete',
      loadingItem: 'Loading...'
    },
    de: {
      complete: 'Bearbeiten',
      loadingItem: 'Wird geladen...'
    }
  })
</script>
<template>
  <Button
    :class="[
      'h-8 font-normal',
      props.class || 'w-[99px]',
      `bg-${themeColor}-600 hover:bg-${themeColor}-700 border-transparent text-white`
    ]"
    :disabled="props.disabled || props.loading"
    :aria-label="props.accessibleName"
    :aria-busy="props.loading || undefined"
  >
    <LoaderCircle
      v-if="props.loading"
      class="h-4 w-4 animate-spin"
      aria-hidden="true"
    />
    <span
      v-if="props.loading"
      class="sr-only"
    >
      {{ t('loadingItem') }}
    </span>
    <span v-else>{{ t('complete') }}</span>
  </Button>
</template>
